;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="89c12665-720f-4158-92e5-7f7601f214d2",e._sentryDebugIdIdentifier="sentry-dbid-89c12665-720f-4158-92e5-7f7601f214d2")}catch(e){}}();import React__default from 'react';
import { LayoutContainer } from '@zooplus/ui-components';
import SearchBar from './SearchBar.js';
import styles from './SearchBar.module.scss.js';
import '../../_virtual/_sentry-release-injection-file.js';

const MobileSearchBar = () => {
    return (React__default.createElement("div", { className: styles.searchBarMobile, "data-zta": "header-search-bar-mobile", id: "mobileSearchBar" },
        React__default.createElement(LayoutContainer, { variant: "default" },
            React__default.createElement(SearchBar, { device: "mobile" }))));
};

export { MobileSearchBar as default };
//# sourceMappingURL=MobileSearchBar.js.map
